import { Injectable } from '@angular/core';
import { GolfClass, Place } from '../../../libs/proto/commUnity_pb';
import { BinaryWriter } from 'google-protobuf';

@Injectable({
  providedIn: 'root'
})
export class GolfClassConversionService {

  constructor() { }

  ToStorage(req: GolfClass) {
    const w = new BinaryWriter();
    GolfClass.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (golfclass: GolfClass, errorConvert: any) => void) {
    try {
      callback( GolfClass.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }
  ToStorages(news: GolfClass[]) {
    const rets = new Array<string>();

    news.forEach(element => {
      rets.push(
        btoa(String.fromCharCode.apply(null,this.ToStorage(element)))
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (golfclasses: GolfClass[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const golfclasses = new Array<GolfClass>();
    const golfclassjs: {data: string[]} = data;
    try {

      golfclassjs.data.forEach(element => {
        const golfclass = GolfClass.deserializeBinary( new Uint8Array([...atob(element)].map(char => char.charCodeAt(0)))  );
        golfclasses.push ( golfclass );
      });

      callback( golfclasses, null);
    } catch (error) {
      callback( null, error);
    }
  }
}
